<template>
  <div class="equipment-log">
    <section class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ pageTitle }}</p>
                  </header>
                </div>
              </div>
              <div class="columns" style="margin-top: 16px">
                <div class="column is-full">
                  <b-field required :label="$t('equipment-log-view.select-date-title')">
                    {{ getFormattedDate(selected_date) }}
                  </b-field>
                  <b-field required :label="$t('equipment-log-view.equipment')">
                    <b-taginput
                        v-if="isInNewMode"
                        maxtags="1"
                        v-model="equipmentsTags"
                        :data="filteredEquipments"
                        :loading="false"
                        :has-counter="false"
                        :open-on-focus="true"
                        autocomplete
                        field="model"
                        icon="robot-industrial"
                        :remove-on-keys=[]
                        :placeholder="$t('equipment-log-view.equipment-placeholder')"
                        tabindex="2"
                        @typing="getFilteredEquipments">
                    </b-taginput>
                    <label v-else>{{ log_data.parent.model }}</label>
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-half">
                  <b-field required :label="$t('equipment-log-view.days')">
                    <b-numberinput :editable="true" tabindex="3" v-model="quantityDay" min="0" step="1">
                    </b-numberinput>
                  </b-field>
                </div>
                <div class="column is-half">
                  <b-field style="margin-top: 40px;">
                    {{remainingQuantity}}
                  </b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <b-field :label="$t('equipment-log-view.text')">
                    <b-input v-model="text"
                              :placeholder="$t('equipment-log-view.text-placeholder')" tabindex="4"
                              type="textarea"></b-input>
                  </b-field>
                  <label v-if="!isFormValid"
                          class="required-field">{{ $t('validation.equipment-log-form') }}
                  </label>
                </div>
              </div>
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column is-narrow">
                  <b-button tabindex="10" class="button" @click="cancelClicked" icon-left="close-thick">
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
                <div class="column is-narrow">
                  <b-button tabindex="11" class="button is-primary" @click="saveClicked" icon-left="content-save">
                    {{ $t('common.save') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "EquipmentLog",
  props: {
    'project_id': {
      type: String,
    },
    'log_data': {},
    'equipments_data': {},
    'selected_date': {}
  },
  data() {
    return {
      equipmentsTags: [],
      filteredEquipments: this.equipments_data,
      quantityDay: 0,
      model: "",
      text: "",
      isLoading: false,
      isFormValid: true
    }
  },
  methods: {
    createEquipmentLog: function (updateData) {
      this.isLoading = true
      const functions = firebase.app().functions(this.$brand.functionsRegion);
      const insertEquipmentLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      updateData.action = "insert_log";
      insertEquipmentLogFunction(updateData).then(() => {
        this.showSuccess(this.$t('messages.equipment-log-created'));
        this.$emit('equipmentLogAdded');
      }).catch((error) => {
        this.showError(this.$t('messages.save-error'))
        console.error("Error writing document:", error?.code);
      });
      this.isLoading = false
    },
    updateEquipmentLog: function (updateData) {
      this.isLoading = true
      const functions = firebase.app().functions(this.$brand.functionsRegion);
      const updateEquipmentLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      updateData.action = "update_log";
      updateEquipmentLogFunction(updateData).then(() => {
        this.isLoading = false
        this.showSuccess(this.$t('messages.equipment-log-updated'));
        this.$emit('equipmentLogUpdated');
      }).catch((error) => {
        this.isLoading = false
        this.showError(this.$t('messages.save-error'))
        console.error("Error writing document:", error?.code);
      });
    },
    getFilteredEquipments(text) {
      this.filteredEquipments = this.equipments_data.filter((option) => {
        return option.equipment.model
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
      })
    },
    validateForm() {
      return this.selected_date != null && this.quantityDay != null && this.quantityDay !== 0
            && ((this.isInNewMode && this.equipmentsTags != null && this.equipmentsTags.length > 0) || (!this.isInNewMode && this.model != ""));
    },
    /*
     UI Events
     */
    cancelClicked: function () {
      this.$emit('close');
    },
    backClicked: function () {
      this.$router.back();
    },
    saveClicked: function () {
      this.isFormValid = true
      if (!this.validateForm()) {
        this.isFormValid = false
        return
      }
      // setting current time to the selected date
      const currentDate = new Date()
      this.selected_date.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds())
      const dataFieldsToUpdate = {
        project_id: this.project_id,
        quantity: this.quantityDay,
        text: this.text
      }
      if (this.isInNewMode){
        dataFieldsToUpdate.date = this.selected_date.toISOString();
        dataFieldsToUpdate.equipment_id = this.equipmentsTags[0].equipment.document_id;
        this.createEquipmentLog(dataFieldsToUpdate);
      } else {
        dataFieldsToUpdate.equipment_id = this.log_data.equipment_id;
        dataFieldsToUpdate.document_id = this.log_data.document_id;
        this.updateEquipmentLog(dataFieldsToUpdate);
      }
    }
  },
  mounted() {
    if (this.isInNewMode && this.currentUserAccess("ProjectLogs", this.UserActions.CREATE, this.project_id)) {
      console.log("add new equipment log");
    } else if (!this.isInNewMode && this.currentUserAccess("ProjectLogs", this.UserActions.UPDATE, this.project_id)){
      console.log("update equipment log");
      this.model = this.log_data.parent.model;
      this.quantityDay = this.log_data.quantity;
      this.text = this.log_data.text; 
    } else {
      console.log("component access denied.");
      this.$emit('close');
    }
  },
  computed: {
    isInNewMode() {
      return this.log_data.document_id === "new";
    },
    pageTitle() {
      if (this.isInNewMode) {
        return this.$t('equipment-log-view.new-log-title')
      } else {
        return this.$t('equipment-log-view.edit-log-title')
      }
    },
    remainingQuantity(){
      let tag;
      let totalQuantity = 0;
      let totalLoggedQuantity = 0;
      let curLogSavedQuantity = 0;
      if (this.isInNewMode) {
        if(this.equipmentsTags[0] === undefined || this.equipmentsTags[0] == null)
           return '';
        tag = this.equipmentsTags[0].equipment;
        if(tag.meta.estimation === undefined || tag.meta.estimation == null)
          return;
        totalLoggedQuantity = tag.logged_quantities;
      }
      else {
        tag = this.log_data;
        totalLoggedQuantity = tag.parent.logged_quantities;
        curLogSavedQuantity = tag.quantity;
      }
      totalQuantity = tag.meta.estimation.quantity;
      let remaining = (totalLoggedQuantity - totalQuantity - curLogSavedQuantity + this.quantityDay).toFixed(3);
      return ((remaining>0) ? this.$t('project-logs.exceeding') : this.$t('project-logs.remaining')) + ": " + Math.abs(remaining);
    }
  }
};
</script>

<style scoped>
.required-field {
  color: red;
  font-size: 10pt;
}
</style>
